import { BRAND } from "@/content/site";
import { Seo } from "@/components/Seo";

const H = ({ children }) => <h2 className="mt-12 mb-3 font-serif text-2xl md:text-3xl text-ink">{children}</h2>;
const P = ({ children }) => <p className="text-base text-stone leading-relaxed mb-4">{children}</p>;

export default function Datenschutz() {
  return (
    <div data-testid="datenschutz-page">
      <Seo
        title="Datenschutzerklärung — WERKVERDUNG"
        description="Datenschutzerklärung von WERKVERDUNG gemäß DSGVO."
        path="/datenschutz"
      />
      <section className="pt-36 md:pt-44 pb-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-bronze">— Datenschutz</span>
          <h1 className="mt-6 font-serif text-4xl md:text-6xl tracking-tight text-ink leading-[1.02]">
            Datenschutzerklärung
          </h1>

          <div className="mt-10">
            <H>1. Verantwortlicher</H>
            <P>
              Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
              {BRAND.owner}<br />
              {BRAND.address.street}<br />
              {BRAND.address.city}<br />
              E-Mail: {BRAND.email}
            </P>

            <H>2. Erhebung und Verarbeitung personenbezogener Daten</H>
            <P>
              Wir verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung einer
              funktionsfähigen Website sowie unserer Inhalte und Leistungen erforderlich ist oder Sie
              uns diese aktiv übermitteln (z. B. über das Kontaktformular).
            </P>

            <H>3. Kontaktformular</H>
            <P>
              Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben
              (Name, E-Mail-Adresse, Projektangaben und Nachricht) zwecks Bearbeitung der Anfrage
              gespeichert und per E-Mail an uns übermittelt. Für den E-Mail-Versand nutzen wir den
              Dienst Resend. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b und f DSGVO.
              Die Daten werden gelöscht, sobald sie für die Erreichung des Zweckes ihrer Erhebung nicht
              mehr erforderlich sind.
            </P>

            <H>4. Kontakt per WhatsApp</H>
            <P>
              Wenn Sie uns über WhatsApp kontaktieren, gelten zusätzlich die Datenschutzbestimmungen von
              WhatsApp (Meta Platforms Ireland Ltd.). Der Inhalt Ihrer Nachricht wird von uns zur
              Bearbeitung Ihrer Anfrage verarbeitet.
            </P>

            <H>5. Hosting</H>
            <P>
              Diese Website wird bei einem Dienstleister gehostet. Beim Aufruf der Website werden
              technisch notwendige Server-Logdaten (z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs)
              verarbeitet, um den sicheren und stabilen Betrieb zu gewährleisten (Art. 6 Abs. 1 lit. f DSGVO).
            </P>

            <H>6. Webanalyse</H>
            <P>
              Zur Verbesserung unseres Angebots kann eine anonymisierte Reichweitenanalyse eingesetzt
              werden. Dabei werden Nutzungsdaten pseudonymisiert ausgewertet. Rechtsgrundlage ist unser
              berechtigtes Interesse gemäß Art. 6 Abs. 1 lit. f DSGVO.
            </P>

            <H>7. Ihre Rechte</H>
            <P>
              Sie haben jederzeit das Recht auf Auskunft (Art. 15 DSGVO), Berichtigung (Art. 16),
              Löschung (Art. 17), Einschränkung der Verarbeitung (Art. 18), Datenübertragbarkeit (Art. 20)
              sowie Widerspruch (Art. 21). Zudem steht Ihnen ein Beschwerderecht bei einer
              Aufsichtsbehörde zu. Zur Ausübung Ihrer Rechte genügt eine formlose Nachricht an die oben
              genannte E-Mail-Adresse.
            </P>

            <H>8. SSL-/TLS-Verschlüsselung</H>
            <P>
              Diese Seite nutzt aus Sicherheitsgründen eine SSL-/TLS-Verschlüsselung. Eine verschlüsselte
              Verbindung erkennen Sie am Schloss-Symbol in Ihrer Browserzeile.
            </P>

            <H>9. Änderungen</H>
            <P>
              Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen
              rechtlichen Anforderungen entspricht.
            </P>

            <p className="mt-10 text-xs text-stone/60 leading-relaxed">
              Hinweis: Diese Datenschutzerklärung ist eine Vorlage und ersetzt keine Rechtsberatung.
              Bitte lassen Sie sie bei Bedarf rechtlich prüfen.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
